<template>
  <div class="d-flex justify-content-center align-items-center main-container">
    <div class="form-container">
      <n-h1 style="--font-size: 60px; --font-weight: 100"></n-h1>
      <n-card size="large" style="--padding-bottom: 30px">
        <n-h2 style="--font-weight: 400">Iniciar sesión</n-h2>
        <n-form size="large" :rules="rules" :model="model" ref="formRef">
          <n-form-item-row label="Correo electrónico" path="email">
            <n-input
              v-model:value="model.email"
              placeholder="Correo electrónico"
            />
          </n-form-item-row>
          <n-form-item-row label="Contraseña" path="password">
            <n-input
              v-model:value="model.password"
              :type="showPassword ? 'text' : 'password'"
              placeholder="Contraseña"
            >
              <template #suffix>
                <i
                  v-if="!showPassword"
                  class="icon-eye-close input-icon"
                  @click="toggleShowPassword"
                ></i>
                <i
                  v-else
                  class="icon-eye-open input-icon"
                  @click="toggleShowPassword"
                ></i>
              </template>
            </n-input>
          </n-form-item-row>
        </n-form>

        <div style="width: 100%" class="d-flex justify-content-center">
          <n-button
            class="login-button"
            type="primary"
            size="large"
            block
            :loading="loading"
            :disabled="disableButton"
            @click="handleSignIn"
            >Iniciar sesión
          </n-button>
        </div>
        <br />
        <div class="send-to-sign-up">
          <p>¿No tienes una cuenta?</p>
          <router-link to="/app/sign-up">Regístrate</router-link>
        </div>
      </n-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import authStore from "../store/auth";
import { useMessage, useLoadingBar } from "naive-ui";

export default {
  name: "SignIn",
  data() {
    return {
      formRef: null,
      showPassword: false,
      loadingBar: useLoadingBar(),
      message: useMessage(),
      disableButton: false,
      model: {
        email: null,
        password: null,
      },
      rules: {
        email: {
          validator(rule, value) {
            let regex = new RegExp("[A-Za-z0-9]+@[A-Za-z0-9]+\.[A-Za-z]{2,3}");
            if (!value) {
              rule.message = "Por favor ingrese una correo electrónico";
              return false;
            } else if (!regex.test(value)) {
              rule.message = "Por favor ingrese una correo electrónico válido";
              return false;
            } else return true;
          },
          required: true,
          trigger: "blur",
        },
        password: {
          validator(rule, value) {
            if (!value) {
              rule.message = "Por favor ingrese una contraseña";
              return false;
            } else if (value.length < 8) {
              rule.message = "La contraseña debe tener al menos 8 caracteres";
              return false;
            } else if (value === value.toLowerCase()) {
              rule.message =
                "La contraseña debe tener al menos 1 caracter en mayúscula";
              return false;
            } else if (!/\d/.test(value)) {
              rule.message = "La contraseña debe tener al menos 1 número";
              return false;
            } else return true;
          },
          required: true,
          trigger: "blur",
        },
      },
      isTheFormValid: true
    };
  },
  computed: {
    ...mapState(authStore, ["isAdmin", "isLoggedIn"]),
  },
  async mounted() {
    if (this.isLoggedIn) {
      this.message.info("Usted posee actualmente una sesión activa", {
        duration: 5000,
      });
      if (this.isAdmin) {
        this.$router.push("/app/dashboard/admin");
      } else {
        this.$router.push("/app/dashboard/user");
      }
    }
  },
  methods: {
    ...mapActions(authStore, ["login"]),
    validateForm() {
      this.$refs.formRef.validate();
      let regex = new RegExp("[A-Za-z0-9]+@[A-Za-z0-9]+\.[A-Za-z]{2,3}");
      if (!this.model.email) {
        this.message.error("Por favor ingrese un correo electrónico");
        this.isTheFormValid = false;
      }
      if (!regex.test(this.model.email)) {
        this.message.error("Por favor ingrese una correo electrónico válido");
        this.isTheFormValid = false;
      }
      if (!this.model.password) {
        this.message.error("Por favor ingrese una contraseña");
        this.isTheFormValid = false;
      }
      if (this.model.password?.length < 8) {
        this.message.error("La contraseña debe tener al menos 8 caracteres");
        this.isTheFormValid = false;
      }
      if (this.model.password === this.model.password?.toLowerCase()) {
        this.message.error(
          "La contraseña debe tener al menos 1 caracter en mayúscula"
        );
        this.isTheFormValid = false;
      }
      if (!/\d/.test(this.model.password)) {
        this.message.error("La contraseña debe tener al menos 1 número");
        this.isTheFormValid = false;
      }
    },
    async handleSignIn() {
      this.validateForm();
      try {
        if (this.isTheFormValid) {
          const res = await this.login(this.model);
          if (res.user.role === "admin") {
            this.$router.push("/app/dashboard/admin");
          } else {
            this.$router.push("/app/plans/list");
          }
        }
        this.isTheFormValid = true;
      } catch (e) {
        console.log(e);
      }
    },
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },
  },
};

</script>


<style scoped>

.send-to-sign-up {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

a {
  text-decoration: none;
  font-weight: 700;
  color: var(--primary-color);
}

a:hover {
  color: var(--primary-color-hover);
}

.login-button {
  margin-top: 0.7rem;
  width: 15%;
  border-radius: 5px;
}

.main-container {
  width: 100vw;
  height: 100vh;
  background-color: #f4f4f4;
}

.form-container {
  width: 50vw;
}

@media (max-width: 900px) {
  .login-button {
    width: 25%;
  }
}

@media (max-width: 550px) {
  .login-button {
    width: 45%;
  }
}
</style>
